import React from 'react'
import PL1 from "../StoreLayouts/PL1"
import PL2 from "../StoreLayouts/PL2"
import PL3 from "../StoreLayouts/PL3"
import PL4 from "../StoreLayouts/PL4"
import PL5 from "../StoreLayouts/PL5"
import PL6 from "../StoreLayouts/PL6"
import PL7 from "../StoreLayouts/PL7"
import PL8 from "../StoreLayouts/PL8"
import PL9 from "../StoreLayouts/PL9"

const LocationRouter = (props) => {
    let location = props.location

    if (location === "pl1"){
        return (
            <PL1 
                tapMenu={props.tapMenu}
                canMenu={props.canMenu}
                filterStyle={props.filterStyle}
                filterBrewery={props.filterBrewery}
                filterItem={props.filterItem}
                refactorAbv={props.refactorAbv}
            />
        )
    } else if (location === "pl2"){
        return (
            <PL2
                tapMenu={props.tapMenu}
                canMenu={props.canMenu}
                filterStyle={props.filterStyle}
                filterBrewery={props.filterBrewery}
                filterItem={props.filterItem}
                refactorAbv={props.refactorAbv}
            />
        )
    } else if (location === "pl3"){
        return (
            <PL3
                tapMenu={props.tapMenu}
                canMenu={props.canMenu}
                filterStyle={props.filterStyle}
                filterBrewery={props.filterBrewery}
                filterItem={props.filterItem}
                refactorAbv={props.refactorAbv}
            />
        )
    } else if (location === "pl4"){
        return (
            <PL4
                tapMenu={props.tapMenu}
                canMenu={props.canMenu}
                filterStyle={props.filterStyle}
                filterBrewery={props.filterBrewery}
                filterItem={props.filterItem}
                refactorAbv={props.refactorAbv}
            />
        )
    } else if (location === "pl5"){
        return (
            <PL5
                tapMenu={props.tapMenu}
                canMenu={props.canMenu}
                filterStyle={props.filterStyle}
                filterBrewery={props.filterBrewery}
                filterItem={props.filterItem}
                refactorAbv={props.refactorAbv}
            />
        )
    } else if (location === "pl6"){
        return (
            <PL6
                tapMenu={props.tapMenu}
                canMenu={props.canMenu}
                filterStyle={props.filterStyle}
                filterBrewery={props.filterBrewery}
                filterItem={props.filterItem}
                refactorAbv={props.refactorAbv}
            />
        )
    } else if (location === "pl7"){
        return (
            <PL7
                tapMenu={props.tapMenu}
                canMenu={props.canMenu}
                filterStyle={props.filterStyle}
                filterBrewery={props.filterBrewery}
                filterItem={props.filterItem}
                refactorAbv={props.refactorAbv}
            />
        )
    } else if (location === "pl8"){
        return (
            <PL8
                tapMenu={props.tapMenu}
                canMenu={props.canMenu}
                filterStyle={props.filterStyle}
                filterBrewery={props.filterBrewery}
                filterItem={props.filterItem}
                refactorAbv={props.refactorAbv}
            />
        )
    } else if (location === "pl9"){
        return (
            <PL9
            tapMenu={props.tapMenu}
            canMenu={props.canMenu}
            filterStyle={props.filterStyle}
            filterBrewery={props.filterBrewery}
            filterItem={props.filterItem}
            refactorAbv={props.refactorAbv}
        />
    )
        
    }
    
    else {
        return ("loading")
    }
    
} 
export default LocationRouter